// extracted by mini-css-extract-plugin
module.exports = {"root":"OurPartners_root__aRGrS","title":"OurPartners_title__QX3E8","partnersWrapper":"OurPartners_partnersWrapper___ugEC"};